<template>
	<div
		class="ks-videoeditor-ov-box"
		:style="box_style"
		@click.stop
		@mousedown.stop.prevent="start('move', $event)">
		<div
			v-for="corner in corners"
			:key="corner"
			class="ks-videoeditor-ov-handle"
			:class="corner"
			@mousedown.stop.prevent="start(corner, $event)"></div>
	</div>
</template>

<script>
import {FRAME_ASPECT} from './constants.js'
import {overlay_height} from './frame.js'

// Selection frame in the preview: drag to move, drag a corner to resize. Must sit directly inside the preview screen.
export default {
	props: {
		item: Object
	},
	data () {
		return {
			corners: ["nw", "ne", "sw", "se"]
		}
	},
	computed: {
		box_style () {
			const o = this.item;
			return {left: o.x + "%", top: o.y + "%", width: o.w + "%", height: overlay_height(o) + "%"};
		}
	},
	beforeDestroy () {
		this.detach();
	},
	methods: {
		start (mode, event) {
			const o = this.item;
			this.drag = {
				mode: mode,
				item: o,
				x: event.clientX,
				y: event.clientY,
				moved: false,
				rect: this.$el.parentElement.getBoundingClientRect(),
				orig: {x: o.x, y: o.y, w: o.w, h: overlay_height(o)}
			};
			window.addEventListener("mousemove", this.move);
			window.addEventListener("mouseup", this.end);
		},
		move (event) {
			const d = this.drag;
			const o = d.item;
			const dx = (event.clientX - d.x) / d.rect.width * 100;
			const dy = (event.clientY - d.y) / d.rect.height * 100;
			// A click without movement is a pick, handled on mouse up
			if (d.mode == "move" && !d.moved && Math.hypot(event.clientX - d.x, event.clientY - d.y) < 4) return;
			d.moved = true;
			if (d.mode == "move") {
				this.change(o, {
					x: _.clamp(d.orig.x + dx, Math.min(0, 100 - d.orig.w), Math.max(0, 100 - d.orig.w)),
					y: _.clamp(d.orig.y + dy, Math.min(0, 100 - d.orig.h), Math.max(0, 100 - d.orig.h))
				});
				return;
			}
			// Aspect ratio stays locked; the corner opposite to the dragged one stays fixed
			const west = d.mode.indexOf("w") >= 0;
			const north = d.mode.indexOf("n") >= 0;
			const w = _.clamp(d.orig.w + (west ? -dx : dx), 5, 200);
			const h = w * FRAME_ASPECT / (o.aspect || FRAME_ASPECT);
			const patch = {w: w};
			if (west) patch.x = d.orig.x + d.orig.w - w;
			if (north) patch.y = d.orig.y + d.orig.h - h;
			this.change(o, patch);
		},
		end (event) {
			const d = this.drag;
			this.detach();
			if (d && d.mode == "move" && !d.moved) {
				this.$emit("pick", {
					x: (event.clientX - d.rect.left) / d.rect.width * 100,
					y: (event.clientY - d.rect.top) / d.rect.height * 100
				});
			}
		},
		change (item, patch) {
			this.$emit("change", item, Object.assign({placed: true}, patch));
		},
		detach () {
			this.drag = undefined;
			window.removeEventListener("mousemove", this.move);
			window.removeEventListener("mouseup", this.end);
		}
	}
}
</script>

<style scoped>
.ks-videoeditor-ov-box { position: absolute; box-sizing: border-box; border: 2px dashed #ffc107; cursor: move; }
.ks-videoeditor-ov-handle { position: absolute; width: 12px; height: 12px; background: #ffc107; border: 1px solid #000; box-sizing: border-box; }
.ks-videoeditor-ov-handle.nw { left: -7px; top: -7px; cursor: nwse-resize; }
.ks-videoeditor-ov-handle.ne { right: -7px; top: -7px; cursor: nesw-resize; }
.ks-videoeditor-ov-handle.sw { left: -7px; bottom: -7px; cursor: nesw-resize; }
.ks-videoeditor-ov-handle.se { right: -7px; bottom: -7px; cursor: nwse-resize; }
</style>
